<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">DEDICATION</h2>
<p class="normal"><i>To Terry, my husband, and our five children, who have been blessings to me. Terry often has a fresh perspective on the quilt that I’ve worked closely with all day. Our three daughters lend their opinions and their grammar and editing skills to my projects. The “peanut gallery” is composed of our two sons, who add much-needed humor to our lives. I am grateful to my family, who have encouraged and supported my quilting interests.</i></p>
<p class="normal"><i>Thanks to my daughters, Mother, sisters, and sister-in-law, who shared a bit into their quilting journey by each writing a “Life Lesson.” They also have given much input into different aspects of this book.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607054221_03_ded.vue?201b2091